import requestManager from "@comp/platformApi/requestManager";
import consoleHelper from "@util/consoleHelper";

export default {

    submitComment(options = {}, callback) {
        requestManager.request({
            url : 'portal/base/comment/add',
            method : 'post',
            data : options
        }, (error, result) => {
            if (error)
            {
                consoleHelper.logError(error);
                return;
            }

            callback(result);
        });
    }

}
